import type { CONTAINER_DATA, CONTAINER_PARAMS, CONTAINER_PARAMS_DEVICE } from './types'

import { DEFAULT_GAP, DEFAULT_MARGIN, DEFAULT_WIDTH, generateForAllDevice } from '../const'
import { devices } from '../devices'

export const DEFAULT_CONTAINER_DATA = (): CONTAINER_DATA => ({
  id: null,
  classes: null,
  type: 'container',
  data: generateForAllDevice({
    document: null,
    hash: null,
    size: 'l',
    crop: 'structured-image-crop-none',
  }),
})

export const DEFAULT_CONTAINER_PARAMS_DEVICE = (): CONTAINER_PARAMS_DEVICE => ({
  hidden: false,
  borderColor: '#000000',
  borderStyle: 'none',
  backgroundColor: null,
  backgroundPosition: 'left-top',
  backgroundAttachment: 'scroll',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'auto',
  layout: 'flex',
  direction: 'row',
  justify: 'flex-start',
  align: 'flex-start',
  gap: DEFAULT_GAP(),
  width: DEFAULT_WIDTH(),
  minHeight: {
    value: 100,
    unit: 'px',
  },
  borderWidth: {
    top: { value: 3, unit: 'px' },
    right: { value: 3, unit: 'px' },
    bottom: { value: 3, unit: 'px' },
    left: { value: 3, unit: 'px' },
  },
  borderRadius: {
    top: { value: 0, unit: 'px' },
    right: { value: 0, unit: 'px' },
    bottom: { value: 0, unit: 'px' },
    left: { value: 0, unit: 'px' },
  },
  padding: {
    top: { value: 0.5, unit: 'rem' },
    right: { value: 0.5, unit: 'rem' },
    bottom: { value: 0.5, unit: 'rem' },
    left: { value: 0.5, unit: 'rem' },
  },
  margin: {
    top: { value: 0, unit: 'rem' },
    right: { value: 0, unit: 'rem' },
    bottom: { value: 1, unit: 'rem' },
    left: { value: 0, unit: 'rem' },
  },
})

export const CONTAINER_ADDITIONAL_DOCUMENTS = () =>
  Object.keys(devices).map((type) => `data.${type}`)

export const DEFAULT_CONTAINER_PARAMS = (): CONTAINER_PARAMS => ({
  tag: 'div',
  pc: {
    ...DEFAULT_CONTAINER_PARAMS_DEVICE(),
    margin: DEFAULT_MARGIN(),
  },
  tablet: DEFAULT_CONTAINER_PARAMS_DEVICE(),
  mobile: DEFAULT_CONTAINER_PARAMS_DEVICE(),
})